export const BLACK = '#000000'
export const MAIN_COLOR = '#1f1fa3'
export const INFO_COLOR = '#297bff'
export const SECONDARY_COLOR = '#47eff0'
export const WARNING_COLOR = '#f9ce6e'
